import ProfileSettings from "~/profile/settings";
import ContentOverlay from "~/content.overlay";

export default class Settings extends ContentOverlay {
	_settings: ProfileSettings;

	constructor() {
		super();
		this._contentName = "settings";
		this._settings = new ProfileSettings(this);
		this._dom = {
			container: this._settings.container,
		};
		this._buildCloseButton();
	}

	activate() {
		if (this.isActive()) {
			return this;
		}

		this._settings.activate();

		return super.activate();
	}

	deactivate() {
		if (!this.isActive()) {
			return this;
		}

		this._settings.deactivate();
		super.deactivate();
		Mapy.getComponent("history").save();

		return this;
	}

	show() {
		Mapy.getComponent("layout").setWidth(1);

		return super.show();
	}

	hide() {
		return super.hide();
	}

	getState() {
		return this._settings.getState();
	}

	setState(state) {
		this._settings.setState();
		super.setState(state);

		return this;
	}
}
